import ReactGA from 'react-ga4';

let initialized = false;

export const init = (): boolean => {
  const isGAEnabled = import.meta.env.VITE_ENV === 'production';
  const gaId = import.meta.env.VITE_GA;

  if (isGAEnabled && gaId && !initialized) {
    ReactGA.initialize(gaId);
    initialized = true;
  }

  return isGAEnabled && initialized;
};

export const logPageView = (path: string): void => {
  if (initialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export default {
  init,
  logPageView
};
